var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup893(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_893",
    "data-name": "Group 893",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.904,
    height: 34.238,
    viewBox: "0 0 22.904 34.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 22.904,
    height: 34.238,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_892",
    "data-name": "Mask Group 892",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M18.069,0H4.835A4.84,4.84,0,0,0,0,4.835V29.4a4.84,4.84,0,0,0,4.835,4.835H18.069A4.84,4.84,0,0,0,22.9,29.4V4.835A4.84,4.84,0,0,0,18.069,0m2.417,29.4h0a2.42,2.42,0,0,1-2.417,2.417H4.835A2.42,2.42,0,0,1,2.417,29.4V4.835A2.42,2.42,0,0,1,4.835,2.418H7.289c0,.035-.02.064-.02.1h0A1.813,1.813,0,0,0,9.082,4.33h4.74a1.813,1.813,0,0,0,1.813-1.813c0-.035-.018-.064-.02-.1h2.454a2.42,2.42,0,0,1,2.417,2.417Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup893);
export default __webpack_public_path__ + "static/media/Group893.e79a4fa9c781ff68fd0e6240ccc2e0b5.svg";
export { ForwardRef as ReactComponent };